<span class="active-filters" *ngIf="filters?.length">
	<div class="filter-list">
		<span class="filters-label">
			{{ 'FILTERS' | translate }}
		</span>
		<mat-chip-list>
			<mat-chip class="filter-item" *ngFor="let filter of filters; let i = index;" (removed)="removeFilter(filter.name)" [title]="filter.values.join(' | ')">
				<span class="filter-name">
					{{ ((analyticsService.facetConfigs[filter.name]?.label) || filter.name) }}

					{{ filter.values?.length === 1 && analyticsService.status.facetconfig[filter.name]?.not
						? ('IS_NOT' | translate | lowercase) : '' }}
				</span>
				<span
					*ngIf="filter.values?.length === 1"
					class="filter-value"
					[title]="analyticsService?.facetValueLabelMap?.[filter.name]?.[filter.values?.[0]] || filter.values[0]"
				>
					: {{ analyticsService?.facetValueLabelMap?.[filter.name]?.[filter.values[0]] || filter.values[0] }}
				</span>
				<span class="value-count" *ngIf="filter.values?.length > 1">
					({{ filter.values.length }}{{ analyticsService?.status?.facetconfig[filter.name] && analyticsService?.status?.facetconfig[filter.name].not ?
						(' ' + ('EXCLUDED' | translate | lowercase)) : '' }})
				</span>
				<button class="remove-button" matChipRemove>
					<i class="fa-solid fa-circle-xmark"></i>
				  </button>
			</mat-chip>
		</mat-chip-list>
		<span class="clear-all" *ngIf="filters?.length" (click)="clearAll()">{{ 'CLEAR_ALL' | translate }}</span>
	</div>
</span>
